import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import SearchNoResultIcon from 'assets/Icons/SearchNoResultIcon';

const NoResultsFound = () => {
  const screens = useBreakpoint();
  return (
    <div className='min-h-[50vh] w-full bg-black flex flex-col items-center justify-center p-8 text-white text-center'>
      <div>
        <div className='w-full flex justify-center pb-4'>
          <SearchNoResultIcon width={screens.lg ? '150' : '80'} />
        </div>

        <h2 className='text-white mb-1 lg:mb-3 text-lg  lg:text-2xl font-semibold lg:font-bold tracking-[0.2px]'>
          No Result Found
        </h2>

        <p className='text-white text-sm lg:text-lg font-normal leading-snug tracking-[-0.5px]'>
          Try changing keywords for a better result.
        </p>
      </div>
    </div>
  );
};

export default NoResultsFound;
